import { PaginatedListFilter } from "../../../components/form/PaginatedList/FilterRow";

type FilterValues = {
  search: string;
  restrictionReason: string;
  infringementType: string;
};

export const getFilters = (
  translate: (_key: string) => string,
): PaginatedListFilter<FilterValues>[] => [
  {
    formKey: "restrictionReason",
    label: translate("list.filters.restrictionReason"),
    options: [
      { label: translate("list.restrictionReasons.manual"), value: "MANUAL" },
    ],
  },
  {
    formKey: "infringementType",
    label: translate("list.filters.infringementType"),
    options: [
      { label: translate("list.infringementTypes.none"), value: "NONE" },
    ],
  },
];

export const getStandartColumns = (
  translate: (_key: string) => string,
  locales: Intl.LocalesArgument,
) => [
  {
    field: "restrictionReason",
    headerName: translate("list.fields.restrictionReason"),
    width: 200,
    sortable: false,
    valueFormatter: (value: string) =>
      translate(`list.restrictionReasons.${value?.toLowerCase()}`),
  },
  {
    field: "infringementType",
    headerName: translate("list.fields.infringementType"),
    sortable: false,
    width: 200,
    valueFormatter: (value: string) =>
      translate(`list.infringementTypes.${value?.toLowerCase()}`),
  },
  {
    field: "note",
    sortable: false,
    headerName: translate("list.fields.note"),
    width: 200,
  },
  {
    field: "created",
    headerName: translate("list.fields.created"),
    width: 200,
    valueFormatter: (value: string) => {
      const date = new Date(value).toLocaleDateString(locales);
      const time = new Date(value).toLocaleTimeString(locales);

      return `${date} ${time}`;
    },
  },
];
